export default __webpack_public_path__ + "static/media/786.c0683e45.png";